import styled from '@emotion/styled'
import { Badge } from 'antd'

export const StyledBadge = styled(Badge)`
  min-width: ${({ size }) => size}px;
  min-height: ${({ size }) => size}px;
`
